import { Box, Center, Image } from '@chakra-ui/react';
import Link from 'next/link';

import MotionBox from 'components/motion/Box';
import { A7Button } from 'components/api7-components';

const Page404 = () => (
  <>
    <MotionBox
      animate={{ y: 20 }}
      transition={{ repeat: Infinity, duration: 2, repeatType: 'reverse' }}
      width={['100%', '70%', '60%', '60%']}
      height="70vh"
      margin="0 auto"
    >
      <Center h="full" width="full">
        <Image
          minHeight="432.35px"
          minWidth="449.92px"
          src="/404 Error-pana.svg"
          alt="Error 404 not found Illustration"
        />
      </Center>
    </MotionBox>

    <Box marginY={4}>
      <Box textAlign="center" marginTop={4}>
        <Link href="/overview" passHref>
          <A7Button width="129px" type="normal" theme="dark">
            Go Back
          </A7Button>
        </Link>
      </Box>
    </Box>
  </>
);

export default Page404;
